import { store } from "@/stores/global.js";
import { getToolToken } from "@/apis/ums/auth";
import { qModEvent } from "@/utils/eventemitter";

let toolName;
const sPATH = `/ums/datatool/feedback/form`;

async function buildURL(path) {
    const url = new URL(`https://${store.env}.quotemedia.com${sPATH}${path}`);
    url.searchParams.append("wmid", store.wmid);
    url.searchParams.append("webmaster_id", store.wmid);
    url.searchParams.append("token", await getToolToken(toolName));
    if (store.sid) url.searchParams.append("sid", store.sid);
    if (url.searchParams.get("token") == "undefined") return { error: "invalid token" };
    return url.toString();
}

export function register(inToolname) {
    toolName = inToolname;
}

async function doFetch(path = "", extra = null) {
    const url = await buildURL(path);
    if (url.error) return url;

    try {
        const response = await fetch(url, {
            credentials: "include",
            ...extra,
        });

        if (!response) {
            return { error: "No response" };
        }

        // Check if the response status indicates an error
        if (!response.ok) {
            if (response.status === 404 && response.url.includes("layout")) {
                return { error: "No layout found. Contact admin to setup a layout." };
            }

            // This checks for status codes outside the 2xx range
            const errorBody = await response.json();

            // Handle specific status codes if needed
            if (response.status === 401 && errorBody.error === "Sid or cookie sid is required") {
                qModEvent({ type: "AUTH", event: "INVALID_SID" });
                return { error: "Please log in to submit feedback" };
            }

            // Return or throw an error message based on the response
            return { error: errorBody.error || response.statusText };
        }

        return await response.json();
    } catch (e) {
        console.error("Fetch error:", e);
        return { error: e };
    }
}

export async function getFeedbackLayout(locale = "en") {
    console.log(locale);
    return await doFetch(`/layout?language=${locale}`);
}

export async function submitFeedback(data, captchaToken) {
    return await doFetch("", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "G-Recaptcha-Response": captchaToken,
        },
        body: JSON.stringify(data),
    });
}
